












































import Vue from "vue";
import Web3 from "web3";
// import { performance } from "perf_hooks";
import * as SimpleStatistics from "simple-statistics";

export default Vue.extend({
  name: "RPCChecker",

  data: () => ({
    isStarted: false as boolean,
    tokenAddress: "" as string,
    btnColor: "primary" as string,
    btnText: "Start" as string,
    items: [] as Array<any>,
    error: "" as string,
  }),
  methods: {
    async click(): Promise<void> {
      if (this.isStarted) {
        return;
      }

      const nodes = [
        "https://bsc-dataseed.binance.org/",
        "https://bsc-dataseed1.binance.org/",
        "https://bsc-dataseed2.binance.org/",
        "https://bsc-dataseed3.binance.org/",
        "https://bsc-dataseed4.binance.org/",
        "https://bsc-dataseed1.defibit.io/",
        "https://bsc-dataseed2.defibit.io/",
        "https://bsc-dataseed3.defibit.io/",
        "https://bsc-dataseed4.defibit.io/",
        "https://bsc-dataseed1.ninicoin.io/",
        "https://bsc-dataseed2.ninicoin.io/",
        "https://bsc-dataseed3.ninicoin.io/",
        "https://bsc-dataseed4.ninicoin.io/",
      ];

      this.isStarted = true;
      // this.btnColor = "secondary";
      // this.btnText = "Stop";
      this.items.splice(0);

      for (const node of nodes) {
        const web3 = new Web3(new Web3.providers.HttpProvider(node));
        const response = [];
        for (const _ of Array(50)) {
          const start = performance.now();
          await web3.eth.getBlockNumber();
          response.push(performance.now() - start);
        }
        const average = SimpleStatistics.sum(response) / response.length;
        const sd = SimpleStatistics.standardDeviation(response);

        this.items.push({
          name: node,
          average: Math.trunc(average),
          sd: Math.trunc(sd),
        });
      }

      this.isStarted = false;
    },
  },
});
